import React, { createContext, useState } from 'react';
import { ReminderItemData, ContractInfo } from './service';

type ReactDistpatch<T> = React.Dispatch<React.SetStateAction<T>>

type OptimusContextStates = {
    reminderList: ReminderItemData[],
    setReminderList: ReactDistpatch<ReminderItemData[]>,

    loanInfos: ContractInfo[],
    setLoanInfos: ReactDistpatch<ContractInfo[]>,

    isFetchError: boolean,
    setIsFetchError: ReactDistpatch<boolean>,

    isFetchLoanInfos: boolean,
    setIsFetchLoanInfos: ReactDistpatch<boolean>
}

const OptimusContext = createContext<OptimusContextStates>({
    reminderList: [],
    setReminderList: () => {},
    loanInfos: [],
    setLoanInfos: () => {},
    isFetchError: false,
    setIsFetchError: () => {},
    isFetchLoanInfos: false,
    setIsFetchLoanInfos: () => {}
});

const OptimusContextProvider = ({ children }) => {
    const [ reminderList, setReminderList ] = useState<ReminderItemData[]>([]);
    const [ isFetchError, setIsFetchError ] = useState<boolean>(false);
    const [ loanInfos, setLoanInfos ] = useState<ContractInfo[]>([]);
    const [ isFetchLoanInfos, setIsFetchLoanInfos ] = useState<boolean>(false);

    return (
        <OptimusContext.Provider
            value={{
                reminderList, setReminderList,
                loanInfos, setLoanInfos,
                isFetchError, setIsFetchError,
                isFetchLoanInfos, setIsFetchLoanInfos
            }}
        >
            {children}
        </OptimusContext.Provider>
    )
}

export { OptimusContext };
export default OptimusContextProvider;